import {css, html} from 'lit';
import {customElement, property} from 'lit/decorators';
import {containerStyles, normalizeStyles, typographyStyles} from "@webs/components-library/theming";
import {GridColumn} from "@webs/components-library/grid-column";

@customElement('webs-card-solid')
export class CardSolid extends GridColumn {

  static styles = [...GridColumn.styles,
    normalizeStyles,
    containerStyles,
    typographyStyles,
    ...GridColumn.styles,
    css`
      .m-cards-solid__card.card--small,
      .m-cards-solid__card.card--large{ padding: 1.6rem 1.6rem 1.9rem 1.6rem; }

      .m-cards-solid__card.card--small .link_arrow { margin-top: 2.5rem; }
      .m-cards-solid__card.card--large .link_arrow { margin-top: 2.5rem; }


      .m-cards-solid__card { background: var(--color-light-grey); border-radius: .4rem; padding: 1.6rem; transition: background .1s linear; display: flex; flex-direction: column; height: 100%; justify-content: space-between; text-decoration: none; }
      .m-cards-solid__card h4 { font-family: var(--font-family-heading); margin-bottom: 1.1rem; }
      .m-cards-solid__card .text_size-intro { color: var(--color-base); font-family: var(--font-family-base); font-size: 1rem; font-weight: var(--font-weight-base); line-height: 1.5; letter-spacing: 0.01em; margin: 0; }
      .m-cards-solid__card .link_arrow { align-items: center; color: var(--color-base); display: flex; font-weight: var(--font-weight-strong); margin-bottom: 0; }
      .m-cards-solid__card .link_arrow svg { margin-left: 6px; }
      .m-cards-solid__card .link_arrow.link_arrow-position-before span { order: 1; }
      .m-cards-solid__card .link_arrow.link_arrow-position-before svg { margin-left: 0; margin-right: 6px; }
      .m-cards-solid__card .link_arrow.link_arrow-down svg { transform: rotate(90deg); }

      // .m-cards-solid__card.card--link:hover { background: linear-gradient(216.4deg, var(--color-orange) 22.12%, var(--color-pink) 110.96%); text-decoration: none; }
      // .m-cards-solid__card.card--link:hover h4,
      // .m-cards-solid__card.card--link:hover .text_size-intro,
      // .m-cards-solid__card.card--link:hover .link_arrow
      //   { color: var(--color-white); }
      // .m-cards-solid__card.card--link:hover .link_arrow svg circle { fill: var(--color-white); }

      .active { background: linear-gradient(216.4deg, var(--color-orange) 22.12%, var(--color-pink) 110.96%); text-decoration: none; }

      .m-cards-solid__card.active h4,
      .m-cards-solid__card.active .text_size-intro,
      .m-cards-solid__card.active .link_arrow
        { color: var(--color-white); }
      .m-cards-solid__card.active .link_arrow svg circle { fill: var(--color-white); }

      @media only screen and (min-width: 992px){
        .m-cards-solid__card.card--link:hover { background: linear-gradient(216.4deg, var(--color-orange) 22.12%, var(--color-pink) 110.96%); text-decoration: none; }
        .m-cards-solid__card.card--link:hover h4,
        .m-cards-solid__card.card--link:hover .text_size-intro,
        .m-cards-solid__card.card--link:hover .link_arrow
          { color: var(--color-white); }
        .m-cards-solid__card.card--link:hover .link_arrow svg circle { fill: var(--color-white); }

        .m-cards-solid__card h4 { font-size: 1.8rem; line-height: 40px; letter-spacing: 0.02em; }
        .m-cards-solid__card.card--small { padding: 1.6rem 2rem; }
        .m-cards-solid__card.card--large { padding: 2.4rem 2rem 2.3rem 2rem; }
        .m-cards-solid__card { padding: 2rem; }
        .m-cards-solid__card .text_size-intro { font-size: 1.05rem; }
        .m-cards-solid__card.card--small .link_arrow { margin-top: 2.4rem; }
        .m-cards-solid__card.card--large .link_arrow { margin-top: 4.2rem; }
      }
    `
  ];

  @property()
  title: string;

  @property()
  description: string;

  @property()
  href: string;

  @property()
  openInNewTab: string;

  @property()
  rel: string;

  @property()
  linkTitle: string;

  @property({attribute: 'arrow-type'})
  arrowType = 'right';

  @property({attribute: 'icon-position'})
  iconPosition = 'after';

  @property()
  size: string;

  @property({attribute: 'card-type'})
  cardType = 'large'

  protected render(): unknown {
    return html`
      ${this.href ? html`
        <a part="card" class="m-cards-solid__card card--link" target="${this.openInNewTab ? '_blank' : ''}" rel="${this.rel ? this.rel : ''}"
           href="${this.href}">
          <div class="card-content">
            ${this.title ? html`<h4>${this.title}</h4>` : ''}
            <p class="text_size-intro">${ this.description }</p>
          </div>
          ${this.linkTitle ? html`
            <p class="link_arrow link_arrow-${this.arrowType} link_arrow-position-${this.iconPosition}">
            <span>${ this.linkTitle }</span>
            <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="7.5" cy="6" r="2" fill="#181A23"/>
              <circle cx="2" cy="2.75" r="2" fill="#181A23"/>
              <circle cx="2" cy="9.25" r="2" fill="#181A23"/>
            </svg>
          </p>` : ''}
        </a>
      ` : html`
        <div part="card" class="m-cards-solid__card card--no-link">
          <div class="card-content">
            ${this.title ? html`<h4>${this.title}</h4>` : ''}
            <p class="text_size-intro">${ this.description }</p>
          </div>
        </div>
      `}
    `;
  }
}
